function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { Chart } from '@finect/tabular-components/Chart';
import { finectAPI } from '@finect/front-utils/finectAPI';
import { range } from '@finect/front-utils/range';
export class DistributionChart extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", {
      distribution: {}
    });
  }
  componentDidMount() {
    finectAPI({
      version: 'bff-admin',
      path: `test/categories?timePeriod=${this.props.timePeriod}&category=${this.props.category}`,
      method: 'GET',
      onSuccess: _ref => {
        let {
          data
        } = _ref;
        this.setState({
          distribution: data.reduce((obj, item) => _objectSpread(_objectSpread({}, obj), {}, {
            [item.realRanking]: item.fondos
          }), {})
        });
      }
    });
  }
  componentDidUpdate(prevProps) {
    if (prevProps.timePeriod !== this.props.timePeriod) {
      finectAPI({
        version: 'bff-admin',
        path: `test/categories?timePeriod=${this.props.timePeriod}&category=${this.props.category}`,
        method: 'GET',
        onSuccess: _ref2 => {
          let {
            data
          } = _ref2;
          this.setState({
            distribution: data.reduce((obj, item) => _objectSpread(_objectSpread({}, obj), {}, {
              [item.realRanking]: item.fondos
            }), {})
          });
        }
      });
    }
  }
  render() {
    const options = {
      chart: {
        type: 'column'
      },
      title: {
        text: null
      },
      accessibility: {
        enabled: false
      },
      subtitle: {
        text: ''
      },
      xAxis: {
        categories: range(80, -15).filter(num => num !== 0).map(num => `${num}%`),
        crosshair: true
      },
      yAxis: {
        min: 0,
        title: {
          text: ''
        }
      },
      tooltip: {
        headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
        pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' + '<td style="padding:0"><b>{point.y:.1f}</b></td></tr>',
        footerFormat: '</table>',
        shared: true,
        useHTML: true
      },
      plotOptions: {
        column: {
          pointPadding: 0,
          borderWidth: 0,
          groupPadding: 0,
          shadow: false
        }
      },
      series: [{
        name: 'Data',
        data: range(80, -15).filter(num => num !== 0).map(num => ({
          y: this.state.distribution && (this.state.distribution[num] || 0),
          color: num < 0 ? 'pink' : 'lightgreen',
          borderColor: num < 0 ? 'red' : 'green',
          borderWidth: 2
        }))
      }]
    };
    return React.createElement("div", {
      style: {
        backgroundColor: 'beige',
        height: '400px'
      }
    }, React.createElement(Chart, {
      options: options
    }));
  }
}